export const WEEK_DAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];

export const VIEW_OPTIONS = ["Mês", "Semana"];

export const VISIBILITY_OPTIONS = [
  {
    value: "PUBLICO",
    label: "Público para todos",
  },
  {
    value: "PESSOAL",
    label: "Pessoal",
  },
  {
    value: "DIRETORIA_ADMIN",
    label: "Diretoria/Admin",
  },
];

export const STATUS_OPTIONS = [
  {
    value: "ATIVO",
    label: "Ativo",
  },
  {
    value: "CANCELADO",
    label: "Cancelado",
  },
];

export const MONTH_EVENT_LIMIT = 2;
